﻿/** custom-sticky-atc.js */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';

    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var dollars = (cents / 100).toFixed(2);
    var noDecimals = String(Math.floor(cents / 100));
    var withCommas = parseFloat(dollars).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return fmt
      .replace('{{amount}}', withCommas)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', withCommas.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  }

  function updateCartCount(count) {
    var n = Number(count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-cart-count', String(n));
    });
    var viewport = document.querySelector('.layout--viewport');
    if (viewport) viewport.setAttribute('data-cart-empty', String(n === 0));
  }

  function openCartDrawer() {
    window.dispatchEvent(new Event('theme:transition:reset:cart-drawer'));
    window.dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        detail: { side: 'right', view: 'cart-drawer', trigger: null },
      })
    );
  }

  function updateAndOpenCartDrawer(sectionHtml) {
    window.addEventListener(
      'theme:cart:updated',
      function () {
        requestAnimationFrame(openCartDrawer);
      },
      { once: true }
    );

    window.dispatchEvent(
      new CustomEvent('theme:cart:drawer:updateHtml', {
        detail: { section: sectionHtml, load_transitions: false },
      })
    );
  }

  function findOverlayEl() {
    return document.querySelector('.drawer--overlay');
  }

  function findRightDrawer() {
    return document.querySelector('.drawer--side[data-side="right"]');
  }

  function isDrawerOpen() {
    var overlay = findOverlayEl();
    if (!overlay) return false;
    return overlay.getAttribute('aria-hidden') === 'false';
  }

  function applyDrawerZIndex() {
    var bar = document.querySelector('.satc-bar');
    if (!bar) return;

    if (!bar.dataset.baseZ) {
      bar.dataset.baseZ = getComputedStyle(bar).zIndex || '200';
    }

    var overlay = findOverlayEl();
    var drawer  = findRightDrawer();
    var zOverlay = overlay ? (parseInt(getComputedStyle(overlay).zIndex, 10) || 0) : 0;
    var zDrawer  = drawer  ? (parseInt(getComputedStyle(drawer).zIndex,  10) || 0) : 0;
    var topZ = Math.max(zOverlay, zDrawer);

    bar.style.zIndex = String(Math.max(topZ - 1, 0) || 1);
    document.body.classList.add('is-cart-drawer-open');
  }

  function restoreZIndex() {
    var bar = document.querySelector('.satc-bar');
    if (!bar) return;
    bar.style.zIndex = bar.dataset.baseZ || '';
    document.body.classList.remove('is-cart-drawer-open');
  }

  window.addEventListener('theme:drawer:open', applyDrawerZIndex);
  window.addEventListener('theme:drawer:close', restoreZIndex);

  (function () {
    var lastDrawerState = null;

    var observer = new MutationObserver(function () {
      var open = isDrawerOpen();
      if (open === lastDrawerState) return; // de-dupe — no redundant calls
      lastDrawerState = open;
      if (open) {
        applyDrawerZIndex();
      } else {
        restoreZIndex();
      }
    });

    function attachObserver() {
      var overlay = findOverlayEl();
      if (!overlay) {
        setTimeout(attachObserver, 500);
        return;
      }
      observer.observe(overlay, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
      lastDrawerState = null; // reset so first real change is always handled
    }

    attachObserver();
  }());
  function StickyATC(el) {
    this.el             = el;
    this.sectionId      = el.dataset.sectionId;
    this.productId      = el.dataset.productId;
    this.footerSelector = el.dataset.footerSelector || 'footer';

    this._barVisible  = false;
    this._atFooter    = false;

    var jsonEl = el.querySelector('.satc-bar__variants-json');
    this.variants = jsonEl ? JSON.parse(jsonEl.textContent.trim()) : [];

    var maxQtyEl = el.querySelector('.satc-bar__max-qty-json');
    this.maxQtyMap = maxQtyEl ? JSON.parse(maxQtyEl.textContent.trim()) : {};

    this.selects   = Array.from(el.querySelectorAll('.satc-bar__select'));
    this.qtyInput  = el.querySelector('.satc-bar__qty-input');
    this.qtyMinus  = el.querySelector('[data-action="minus"]');
    this.qtyPlus   = el.querySelector('[data-action="plus"]');
    this.ctaBtn    = el.querySelector('.satc-bar__cta');
    this.errorEl   = el.querySelector('.satc-bar__error');
    this.defaultQty = Math.max(1, parseInt(this.qtyInput && this.qtyInput.defaultValue, 10) || 1);

    // KCP promotion settings — read from data attributes written by Liquid
    this.kcpEnabled  = el.dataset.kcpEnabled === 'true';
    this.kcpDiscount = parseInt(el.dataset.kcpDiscount || '15', 10);

    this.selectedOptions = this.selects.map(function (s) { return s.value; });
    this.currentVariant = this._findVariant();

    this._bindEvents();
    this._initVisibilityObservers();
    this._initMainFormSync();
    this._updateButton(this.currentVariant);
    this._applyMaxQty();

    document.body.classList.add('has-satc-bar');
  }

  StickyATC.prototype._findVariant = function () {
    var self = this;
    if (self.selects.length === 0) {
      var hiddenInput = self.el.querySelector('[data-satc-variant-id]');
      var hiddenId = hiddenInput ? parseInt(hiddenInput.value, 10) : 0;
      if (hiddenId) {
        return self.variants.find(function (v) { return v.id === hiddenId; }) || self.variants[0] || null;
      }
      return self.variants[0] || null;
    }

    return (
      self.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return String(opt) === String(self.selectedOptions[i]);
        });
      }) || null
    );
  };

  StickyATC.prototype._showBar = function () {
    this._barVisible = true;
    this.el.setAttribute('aria-hidden', 'false');
    this.el.classList.add('is-visible');
  };

  StickyATC.prototype._hideBar = function () {
    this._barVisible = false;
    this.el.classList.remove('is-visible');
    this.el.setAttribute('aria-hidden', 'true');
  };

  StickyATC.prototype._initVisibilityObservers = function () {
    var self = this;


    var atcButton =
      document.querySelector('.product-buy-buttons--primary') ||
      document.querySelector('form[action*="/cart/add"]');

    //console.debug('[StickyATC] ATC target element:', atcButton);

    function checkAtcPosition() {
      if (!atcButton) {
       
        if (window.scrollY > 300) {
          self._showBar();
        } else {
          self._hideBar();
        }
        return;
      }

      var rect = atcButton.getBoundingClientRect();
      //console.debug('[StickyATC] ATC rect:', rect.top, rect.bottom);

      // ATC button visible anywhere in viewport → keep sticky hidden
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        self._hideBar();
        return;
      }

      // ATC button scrolled above viewport (user passed it) → show sticky
      if (rect.bottom <= 0) {
        self._showBar();
        return;
      }

      // ATC button still below screen (not reached yet) → keep hidden
      self._hideBar();
    }

    window.addEventListener('scroll', checkAtcPosition, { passive: true });
    window.addEventListener('resize', checkAtcPosition, { passive: true });

    // Evaluate after a short paint delay so layout is settled
    setTimeout(checkAtcPosition, 100);

    var footer = document.querySelector(this.footerSelector);
    if (footer) {
      var footerSpaceObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var height = self.el.offsetHeight;
              document.documentElement.style.setProperty('--satc-footer-space', height + 'px');
              document.body.classList.add('satc-footer-visible');
            } else {
              document.documentElement.style.removeProperty('--satc-footer-space');
              document.body.classList.remove('satc-footer-visible');
            }
          });
        },
        { threshold: 0 }
      );
      footerSpaceObserver.observe(footer);
      this._footerSpaceObserver = footerSpaceObserver;
    }
  };

  StickyATC.prototype._bindEvents = function () {
    var self = this;

    this.selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        self._handleOptionChange(sel);
      });
    });

    if (this.qtyInput) {
      var _prevQtyVal;
      this.qtyInput.addEventListener('keydown', function (e) {
        var key = e.which || e.keyCode;
        // Allow: digits (48-57), numpad digits (96-105), arrow keys (37-40),
        //        Backspace (8), Tab (9), Delete (46)
        var isDigit   = (key >= 48 && key <= 57) || (key >= 96 && key <= 105);
        var isControl = key === 8 || key === 9 || key === 46;
        var isArrow   = key >= 37 && key <= 40;
        if (!isDigit && !isControl && !isArrow) {
          e.preventDefault();
        }
      });

      this.qtyInput.addEventListener('focusin', function () {
        _prevQtyVal = parseInt(this.value, 10) || 1;
      });

      this.qtyInput.addEventListener('focusout', function () {
        var val = parseInt(this.value, 10);
        var clamped = (val && val >= 1) ? val : (_prevQtyVal || 1);
        var max = self._getMaxQty();
        if (max != null && clamped > max) clamped = max;
        this.value = clamped;
        self._applyMaxQty();
      });
    }

    if (this.qtyMinus) {
      this.qtyMinus.addEventListener('click', function () { self._adjustQty(-1); });
    }
    if (this.qtyPlus) {
      this.qtyPlus.addEventListener('click', function () { self._adjustQty(1); });
    }

    if (this.ctaBtn) {
      this.ctaBtn.addEventListener('click', function () { self._addToCart(); });
    }
  };

  StickyATC.prototype._handleOptionChange = function (sel) {
    var idx = parseInt(sel.dataset.optionIndex, 10);
    this.selectedOptions[idx] = sel.value;

    this.currentVariant = this._findVariant();
    this._updateButton(this.currentVariant);
    this._syncMainForm(this.currentVariant);
    this._resetQtyToDefault();
    this._applyMaxQty();
  };

  StickyATC.prototype._resetQtyToDefault = function () {
    if (!this.qtyInput) return;
    this.qtyInput.value = this.defaultQty;
  };

  StickyATC.prototype._updateButton = function (variant) {
    var btn     = this.ctaBtn;
    if (!btn) return;

    // Keep hidden variant-id input in sync
    var hiddenInput = this.el.querySelector('[data-satc-variant-id]');
    if (hiddenInput && variant) hiddenInput.value = variant.id;

    var labelEl = btn.querySelector('.satc-bar__cta-label');
    var priceEl = btn.querySelector('.satc-bar__cta-price');

    if (!variant) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.removeAttribute('data-variant-id');
      if (labelEl) labelEl.textContent = 'Unavailable';
      if (priceEl) priceEl.innerHTML = '';
      return;
    }

    btn.dataset.variantId = variant.id;

    if (!variant.available) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      if (labelEl) labelEl.textContent = 'SOLD OUT';
      if (priceEl) {
        if (this.kcpEnabled) {
          var kcpSoldCents = Math.floor(variant.price * (100 - this.kcpDiscount) / 100);
          priceEl.innerHTML =
            '<s class="satc-price--compare">' + formatMoney(variant.price) + '</s>' +
            '<span class="satc-price--sale">' + formatMoney(kcpSoldCents) + '</span>';
        } else {
          priceEl.innerHTML =
            '<span class="satc-price--regular">' + formatMoney(variant.price) + '</span>';
        }
      }
      return;
    }

    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    if (labelEl) labelEl.textContent = 'ADD TO BAG';

    if (!priceEl) return;

    var price   = formatMoney(variant.price);
    var compare = variant.compare_at_price;

    // KCP promotion: show discounted price + struck-through original
    if (this.kcpEnabled) {
      var kcpCents = Math.floor(variant.price * (100 - this.kcpDiscount) / 100);
      priceEl.innerHTML =
        '<s class="satc-price--compare">' + price + '</s>' +
        '<span class="satc-price--sale">' + formatMoney(kcpCents) + '</span>' ;
    } else if (compare && compare > variant.price) {
      var compareFmt = formatMoney(compare);
      priceEl.innerHTML =
        '<s class="satc-price--compare">' + compareFmt + '</s>' +
        '<span class="satc-price--sale">' + price + '</span>';
    } else {
      priceEl.innerHTML =
        '<span class="satc-price--regular">' + price + '</span>';
    }
  };

  StickyATC.prototype._getMaxQty = function () {
    if (!this.currentVariant) return null;
    var max = this.maxQtyMap[String(this.currentVariant.id)];
    return (max != null && parseInt(max, 10) > 0) ? parseInt(max, 10) : null;
  };

  StickyATC.prototype._applyMaxQty = function () {
    if (!this.qtyInput) return;
    var max = this._getMaxQty();
    var current = parseInt(this.qtyInput.value, 10) || 1;
    if (max != null) {
      this.qtyInput.setAttribute('max', String(max));
      if (current > max) {
        this.qtyInput.value = max;
        current = max;
      }
      if (this.qtyPlus) this.qtyPlus.toggleAttribute('disabled', current >= max);
    } else {
      this.qtyInput.removeAttribute('max');
      if (this.qtyPlus) this.qtyPlus.removeAttribute('disabled');
    }
    if (this.qtyMinus) {
      this.qtyMinus.toggleAttribute('disabled', (parseInt(this.qtyInput.value, 10) || 1) <= 1);
    }
  };

  StickyATC.prototype._adjustQty = function (delta) {
    if (!this.qtyInput) return;
    var current = parseInt(this.qtyInput.value, 10) || 1;
    var max = this._getMaxQty();
    var newVal = Math.max(1, current + delta);
    if (max != null && newVal > max) newVal = max;
    this.qtyInput.value = newVal;
    this._applyMaxQty();
  };

  StickyATC.prototype._initMainFormSync = function () {
    var self = this;

    var mainForm =
      document.querySelector('.main-product--root .product-form') ||
      document.querySelector('.product-form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (mainForm) {
      var idInput = mainForm.querySelector('input[name="id"]');
      if (idInput) {
        var observer = new MutationObserver(function () {
          var newId = parseInt(idInput.value, 10);
          var v = self.variants.find(function (v) { return v.id === newId; });
          if (v) {
            self.currentVariant = v;
            self._updateSelectsForVariant(v);
            self._updateButton(v);
            self._resetQtyToDefault();
            self._applyMaxQty();
          }
        });
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var v = self.variants.find(function (v) { return v.id === e.detail.variant.id; });
      if (!v) return;
      self.currentVariant = v;
      self._updateSelectsForVariant(v);
      self._updateButton(v);
      self._resetQtyToDefault();
      self._applyMaxQty();
    });
  };

  StickyATC.prototype._updateSelectsForVariant = function (variant) {
    if (!variant || !Array.isArray(variant.options)) return;
    variant.options.forEach(function (optVal, idx) {
      var sel = this.selects[idx];
      if (sel && sel.value !== String(optVal)) {
        sel.value = String(optVal);
        this.selectedOptions[idx] = String(optVal);
      }
    }, this);
    // Keep hidden input in sync
    var hiddenInput = this.el.querySelector('[data-satc-variant-id]');
    if (hiddenInput) hiddenInput.value = variant.id;
  };

  StickyATC.prototype._syncMainForm = function (variant) {
    if (!variant) return;
    var mainForm =
      document.querySelector('.main-product--root .product-form') ||
      document.querySelector('.product-form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!mainForm) return;
    var idInput = mainForm.querySelector('input[name="id"]');
    if (idInput && idInput.value !== String(variant.id)) {
      idInput.value = variant.id;
    }
  };

  /**
   * Resolve the variant ID to add to cart.
   * Priority: currentVariant > CTA button data-attr > hidden input > first variant.
   * @returns {number|null}
   */
  StickyATC.prototype._resolveVariantId = function () {
    if (this.currentVariant) return this.currentVariant.id;
    var ctaId = this.ctaBtn && parseInt(this.ctaBtn.dataset.variantId, 10);
    if (ctaId) return ctaId;
    var hiddenInput = this.el.querySelector('[data-satc-variant-id]');
    if (hiddenInput && hiddenInput.value) return parseInt(hiddenInput.value, 10);
    return this.variants.length ? this.variants[0].id : null;
  };

  StickyATC.prototype._addToCart = function () {
    var self = this;

    var variantId = self._resolveVariantId();
    if (!variantId) return;

    var variant = self.currentVariant ||
      self.variants.find(function (v) { return v.id === variantId; });
    if (variant && !variant.available) return;

    if (self.ctaBtn && self.ctaBtn.getAttribute('aria-busy') === 'true') return;

    var quantity = parseInt(self.qtyInput ? self.qtyInput.value : '1', 10) || 1;
    var maxQty = self._getMaxQty();
    if (maxQty != null && quantity > maxQty) quantity = maxQty;

    // Cart-aware cap pre-flight: mirror PDP submit guard so the user sees the
    // exact same "You can only purchase a maximum of N of the [Product] [Variant]
    // per order." message rather than a generic add-to-cart failure.
    var capCheck = (window.MaxQty && maxQty != null)
      ? window.MaxQty.ensureCartLoaded().then(function () {
          var inCart = window.MaxQty.getInCart(variantId);
          var remaining = Math.max(0, maxQty - inCart);
          if (remaining <= 0) {
            var titleEl = self.el.querySelector('.satc-bar__product-title');
            var productTitle = titleEl ? (titleEl.textContent || '').trim().replace(/\s+/g, ' ') : '';
            var vTitle = (variant && variant.title) || window.MaxQty.getVariantTitle(variantId) || '';
            if (/^default\s*title$/i.test(vTitle)) vTitle = '';
            var label = '';
            if (productTitle) { label = ' of the ' + productTitle; if (vTitle) label += ' ' + vTitle; }
            else if (vTitle) { label = ' (' + vTitle + ')'; }
            self._showError('You can only purchase a maximum of ' + maxQty + label + ' per order.');
            return false;
          }
          if (quantity > remaining) quantity = remaining;
          return true;
        })
      : Promise.resolve(true);

    capCheck.then(function (proceed) {
      if (!proceed) return;

      self._setLoading(true);
      self._clearError();

      var CartClass = window.customElements && window.customElements.get('cart-element');

      if (CartClass) {
        var sections = CartClass.sections || ['cart-drawer'];
        var fetchOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity, sections: sections }),
        };

        CartClass.addItems(fetchOptions, self.ctaBtn)
          .then(function () {
            self._setLoading(false);
          })
          .catch(function (err) {
            self._setLoading(false);
            self._showError((err && err.message) || 'Could not add to cart — please try again.');
          });

      } else {
        // Fallback when cart-element is not yet registered (should not happen in practice).
        var cartAddUrl =
          ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
          'cart/add.js';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity, sections: ['cart-drawer'] }),
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || ('HTTP ' + r.status)); });
            return r.json();
          })
          .then(function () {
            self._setLoading(false);
            window.addEventListener('theme:cart:updated', function () {
              requestAnimationFrame(openCartDrawer);
            }, { once: true });
            window.dispatchEvent(new Event('theme:cart:refresh'));
          })
          .catch(function (err) {
            self._setLoading(false);
            self._showError(err.message);
          });
      }
    });
  };

  StickyATC.prototype._setLoading = function (loading) {
    if (!this.ctaBtn) return;
    this.ctaBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  StickyATC.prototype._showError = function (msg) {
    var el = this.errorEl;
    if (!el) return;
    el.textContent = msg || 'Could not add to cart — please try again.';
    el.removeAttribute('hidden');
    clearTimeout(this._errorTimer);
    this._errorTimer = setTimeout(function () {
      el.setAttribute('hidden', '');
    }, 4000);
  };

  StickyATC.prototype._clearError = function () {
    if (!this.errorEl) return;
    clearTimeout(this._errorTimer);
    this.errorEl.setAttribute('hidden', '');
  };

  // ─────────────────────────────────────────────────────────────────
  // Bootstrap
  // ─────────────────────────────────────────────────────────────────

  function initAll() {
    document.querySelectorAll('.satc-bar').forEach(function (el) {
      // Portal: move bar to direct child of <body> so it is in the root
      // stacking context and z-index math is not affected by transformed parents.
      if (el.parentElement && el.parentElement !== document.body) {
        document.body.appendChild(el);
        //console.debug('[StickyATC] Bar portalled to document.body');
      }
      if (!el.dataset.satcInit) {
        el.dataset.satcInit = '1';
        new StickyATC(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target && e.target.querySelector('.satc-bar');
    if (bar) {
      delete bar.dataset.satcInit;
      initAll();
    }
  });

})();

// iOS carousel counter fix
(function () {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIOS) return;

  var sx = 0;
  var startCarousel = null;

  document.addEventListener('touchstart', function (e) {
    sx = e.touches[0].pageX;
    startCarousel = e.target.closest ? e.target.closest('product-carousel') : null;
  }, { passive: true, capture: true });

  window.addEventListener('touchend', function (e) {
    var c = startCarousel;
    startCarousel = null;
    if (!c || e.changedTouches.length > 1) return;

    var dx = e.changedTouches[0].pageX - sx;
    if (Math.abs(dx) < 30) return;

    c.swipe_state = 'swipe-started';

    var count = c.active_slide_count || 1;
    var current = typeof c.active_slide === 'number' ? c.active_slide : 1;
    var target = current + (dx < 0 ? 1 : -1);

    if (target >= 1 && target <= count && typeof c.updateThenGoToActiveSlide === 'function') {
      c.slide_pause = false;
      c.updateThenGoToActiveSlide(target, true);
    } else if (typeof c.swipeTo === 'function') {
      c.swipeTo(dx < 0);
    } else {
      window.dispatchEvent(new CustomEvent(dx < 0 ? 'theme:swipe:left' : 'theme:swipe:right'));
    }
    c.swipe_state = 'swipe-ended';
  }, { passive: true, capture: true });
})();
